"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFiles = exports.deserialize = exports.serialize = exports.clearCart = exports.removeFromCart = exports.addToCart = exports.fetchCartSuccess = exports.fetchCart = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const monocle_ts_1 = require("monocle-ts");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const lib_1 = require("@caddigital/sok-types/lib");
const ActionTypes = require("../actionTypes/cart");
const AuthActionTypes = require("../actionTypes/auth/login");
const Actions = require("../actions/cart");
const errorHandling_1 = require("../utils/errorHandling");
const cartItems = monocle_ts_1.Lens.fromPath([
    'cart',
    'data',
    'items'
]);
const nullToArray = (items) => (Array.isArray(items) ? items : []);
// fetchCart: FETCH_ITEMS_REQUEST -> DESERIALIZE_REQUEST -> DESERIALIZE_SUCCESS -> FETCH_ITEMS_SUCCESS
function fetchCart(action$) {
    return action$.ofType(ActionTypes.FETCH_ITEMS_REQUEST).pipe((0, operators_1.mergeMap)((x) => (0, rxjs_1.of)(Actions.deserialize(x.rootId))));
}
exports.fetchCart = fetchCart;
function fetchCartSuccess(action$) {
    return action$.ofType(ActionTypes.DESERIALIZE_SUCCESS).pipe((0, operators_1.mergeMap)(({ result }) => (0, rxjs_1.of)(Actions.fetchItemsSuccess(result.data))));
}
exports.fetchCartSuccess = fetchCartSuccess;
// addToCart: ADD_ITEM -> SERIALIZE
function addToCart(action$) {
    return action$.ofType(ActionTypes.ADD_ITEMS).pipe((0, operators_1.mergeMap)((x) => (0, rxjs_1.of)(Actions.serialize(x.rootId))));
}
exports.addToCart = addToCart;
function removeFromCart(action$) {
    return action$.ofType(ActionTypes.REMOVE_ITEMS).pipe((0, operators_1.mergeMap)((x) => (0, rxjs_1.of)(Actions.serialize(x.rootId))));
}
exports.removeFromCart = removeFromCart;
function clearCart(action$, store) {
    return action$.pipe((0, operators_1.filter)((x) => x.type === ActionTypes.CLEAR_ALL || x.type === AuthActionTypes.LOGOUT), (0, operators_1.mergeMap)((x) => {
        const state = store.value;
        if (x.type === AuthActionTypes.LOGOUT) {
            if (state.project.currentProject.status === 'FETCHED') {
                return (0, rxjs_1.of)(Actions.serialize(state.project.currentProject.project.rootFolder));
            }
            return (0, rxjs_1.empty)();
        }
        return (0, rxjs_1.of)(Actions.serialize(x.rootId));
    }));
}
exports.clearCart = clearCart;
function serialize(action$, store, { storage }) {
    return action$.pipe((0, operators_1.filter)((x) => x.type === ActionTypes.SERIALIZE_REQUEST), (0, operators_1.mergeMap)((x) => {
        const state = store.value;
        const rootId = !!x && x.rootId ? x.rootId : '';
        return storage
            .setItem(`@sok/cart/items/${rootId}`, cartItems.get(state))
            .pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.serializeSuccess())));
    }));
}
exports.serialize = serialize;
function deserialize(action$, store, { storage }) {
    return action$.pipe((0, operators_1.filter)((x) => x.type === ActionTypes.DESERIALIZE_REQUEST), (0, operators_1.mergeMap)((x) => {
        const rootId = !!x && x.rootId ? x.rootId : '';
        return storage
            .getItem(`@sok/cart/items/${rootId}`)
            .pipe((0, operators_1.mergeMap)((response) => ActionTypes.iDeserializeSuccessData
            .decode(nullToArray(response))
            .fold((e) => (0, rxjs_1.of)(Actions.deserializeFailure((0, errorHandling_1.parseValidationError)(e)), Actions.fetchItemsFailure((0, errorHandling_1.parseValidationError)(e))), (res) => (0, rxjs_1.of)(Actions.deserializeSuccess(res)))), (0, operators_1.catchError)((x) => (0, rxjs_1.of)(Actions.deserializeFailure(x))));
    }));
}
exports.deserialize = deserialize;
function fetchFiles(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_FILES), (0, operators_1.mergeMap)((action) => {
        const uuids = action.payload.files.map((f) => f.uuid);
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: { uuids: uuids },
            url: `${baseUrl}api/files/resource?hierarchyType=MINIMAL&onlySelf=true`
        }).pipe((0, operators_1.mergeMap)(({ response }) => t
            .array(t.union([lib_1.File._iFolderMinimal, lib_1.File._iRevisionMinimal]))
            .decode(response.files)
            .fold((error) => redux_observable_1.ActionsObservable.of(Actions.fetchFilesFailure((0, errorHandling_1.parseValidationError)(error))), (res) => {
            return redux_observable_1.ActionsObservable.of(Actions.fetchFilesSuccess(res));
        })), (0, operators_1.catchError)((error) => redux_observable_1.ActionsObservable.of(Actions.fetchFilesFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))), (0, operators_1.takeUntil)(action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CANCEL_FETCH))));
    }));
}
exports.fetchFiles = fetchFiles;
//# sourceMappingURL=cart.js.map